export default {
  container: {
    margin: '0 300px',
    [`@media (max-width: 1440px)`]: {
      maxWidth: '918px',
      margin: '0 auto',
      padding: '0 40px'
    },
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      position: 'fixed',
      left: '0',
      top: '0',
      width: '100vw',
      height: '100vh',
      zIndex: '100',
      background: '#F8F8F8',
      padding: '0 70px 0 0'
    }
  },
  portraitPlaceholder: {
    position: 'fixed',
    bottom: '0',
    top: '50px',
    width: '100%',
    zIndex: '100'
  },
  notFound: {
    marginTop: '10vh'
  }
}
